'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withScript;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withScript(WrappedComponent, id, src, innerHTML) {
    return function (_React$Component) {
        _inherits(_class2, _React$Component);

        function _class2(props) {
            _classCallCheck(this, _class2);

            var _this = _possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this, props));

            _this.onScriptLoad = function () {
                _this.setState({
                    loaded: true,
                    error: false
                });
            };

            _this.onScriptError = function () {
                var cachedScripts = _this.props.context.cachedScripts;
                var index = cachedScripts.indexOf(src);
                if (index >= 0) {
                    cachedScripts.splice(index, 1);
                    _this.props.context.doReduceScriptCache(cachedScripts);
                }

                var script = document.getElementById(id);
                script.remove();

                _this.setState({
                    loaded: true,
                    error: true
                });
            };

            _this.state = {
                loaded: false,
                error: false,
                script: null
            };
            return _this;
        }

        _createClass(_class2, [{
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps) {
                return true;
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (src && src.includes('@&') && src.includes('&@')) {
                    var key = src.substring(src.indexOf('@&') + 2, src.indexOf('&@'));
                    src = src.replace('@&' + key + '&@', this.props.context.configuration[key]);
                }
                if (innerHTML && innerHTML.includes('@&') && innerHTML.includes('&@')) {
                    var _key = innerHTML.substring(innerHTML.indexOf('@&') + 2, innerHTML.indexOf('&@'));
                    innerHTML = innerHTML.replace('@&' + _key + '&@', this.props.context.configuration[_key]);
                }
                if (this.props.context && this.props.context.scriptCache && this.props.context.scriptCache.length > 0 && this.props.context.scriptCache.includes(src)) {
                    this.setState({
                        loaded: true,
                        error: false
                    });
                } else {
                    var cachedScripts = this.props.context && this.props.context.scriptCache || [];

                    cachedScripts.push(src);

                    var script = document.createElement('script');
                    script.id = id;
                    if (src) script.src = src;
                    if (innerHTML) {
                        script.innerHTML = innerHTML;
                        script.type = 'text/javascript';
                        this.onScriptLoad();
                    }

                    script.async = true;

                    script.addEventListener('load', this.onScriptLoad);
                    script.addEventListener('error', this.onScriptError);

                    document.body.appendChild(script);

                    this.props.context && this.props.context.doReduceScriptCache && this.props.context.doReduceScriptCache(cachedScripts);
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var script = document.getElementById(id);
                script.removeEventListener('load', this.onScriptLoad);
                script.removeEventListener('error', this.onScriptError);
            }
        }, {
            key: 'render',
            value: function render() {
                return this.state.loaded && _react2.default.createElement(WrappedComponent, this.props);
            }
        }]);

        return _class2;
    }(_react2.default.Component);
}